import { EnumValues } from '@/services/types/EnumValues';

export const WalletTypeEnum = {
  EVERYDAY: 'everyday',
  GROWTH: 'growth',
  INVESTMENT: 'investment',
  GLOBAL: 'global'
} as const;
export type WalletTypeEnum = EnumValues<typeof WalletTypeEnum>;
